<template>
    <div>
        <v-checkbox
                v-model="formData.admin"
                label="Admin"
                :error-messages="adminErrors"
                @input="$v.formData.admin.$touch()"
                @blur="$v.formData.admin.$touch()"
        ></v-checkbox>
        <v-checkbox
                v-model="formData.entrant"
                label="Entrant"
                :error-messages="entrantErrors"
                @input="$v.formData.entrant.$touch()"
                @blur="$v.formData.entrant.$touch()"
        ></v-checkbox>
        <v-checkbox
                v-model="formData.judge"
                label="Judge"
                :error-messages="judgeErrors"
                @input="$v.formData.judge.$touch()"
                @blur="$v.formData.judge.$touch()"
        ></v-checkbox>
        <v-checkbox
                v-model="formData.member"
                label="Member"
                :error-messages="memberErrors"
                @input="$v.formData.member.$touch()"
                @blur="$v.formData.member.$touch()"
        ></v-checkbox>
    </div>
</template>

<script>
  import {FieldsMixin} from '@/forms/mixins'

  export default {
    name: 'UserProfileFields',
    mixins: [FieldsMixin],
    data: () => ({
      formData: {
        admin: false,
        entrant: true,
        judge: false,
        member: false,
        sysadmin: false,
      }
    }),
    validations: {
      formData: {
        admin: {
        },
        entrant: {
        },
        judge: {
        },
        member: {
        }
      }
    },
    computed: {
      adminErrors () {
        const errors = []
        if (!this.$v.formData.admin.$dirty) return errors
        return errors
      },
      entrantErrors () {
        const errors = []
        if (!this.$v.formData.entrant.$dirty) return errors
        return errors
      },
      judgeErrors () {
        const errors = []
        if (!this.$v.formData.judge.$dirty) return errors
        return errors
      },
      memberErrors () {
        const errors = []
        if (!this.$v.formData.member.$dirty) return errors
        return errors
      }
    }
  }
</script>

<style scoped>

</style>
